import { useContext } from 'react';
import { TimeContext } from './TimeContext';

export const useTime = () => useContext<Date>(TimeContext);
